export const enumForSelect = (enumObj: any) => {
    return Object.keys(enumObj).map(
        (val:string) => {
            if(isNaN(Number(val))) {
                return {value: val, label: enumObj[val as keyof typeof enumObj]};
            }
        }
    );
};